import React from 'react';
import Icon from '@pushpay/icon';

const FeedbackIcon = props => {
  return /*#__PURE__*/React.createElement(Icon, Object.assign({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20.333 3H3.667C2.746 3 2 3.732 2 4.636v11.088c.002.883.732 1.596 1.63 1.594h2.12v2.863c0 .452.372.818.832.819.17 0 .336-.05.476-.146l5.202-3.536h8.073c.921 0 1.667-.733 1.667-1.637V4.636C22 3.732 21.254 3 20.333 3zm0 12.477a.207.207 0 01-.208.204H12c-.17 0-.335.051-.474.146l-4.11 2.792V16.5a.826.826 0 00-.833-.818H3.875a.207.207 0 01-.208-.204V4.84c0-.113.093-.205.208-.205h16.25c.115 0 .208.092.208.205v10.636zM7 9.137h10c.46 0 .833-.367.833-.82A.826.826 0 0017 7.5H7a.826.826 0 00-.833.818c0 .452.373.818.833.818zm0 3.68h10c.46 0 .833-.366.833-.817A.826.826 0 0017 11.18H7a.826.826 0 00-.833.819c0 .451.373.818.833.818z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

export default FeedbackIcon;